<template>
  <v-footer padless data-test-footer>
    <v-card :img="overlaySrc" flat tile width="100%">
      <v-container>
        <v-card flat color="transparent" class="mx-auto card-outter rounded-0">
          <v-row class="mt-16" v-if="showLogo">
            <v-img class="mx-6" :src="logoDamageReport" contain max-width="300"></v-img>
          </v-row>
          <v-row class="mt-8">
            <v-col cols="4">
              <v-card color="transparent" flat>
                <v-card-text>
                  {{ partnerProp.companyName }}<br />

                  <span v-if="address">{{ address.street }}</span>
                  <br />
                  <span v-if="address">
                    {{ address.zip }}
                    {{ address.city }}
                  </span>
                </v-card-text>
                <v-card-text>
                  <span v-if="settings"> {{ $t("partner.PartnerFooter.mail", { mail: settings.contact.email }) }}</span
                  ><br />

                  <span v-if="settings">
                    {{ $t("partner.PartnerFooter.phone", { phone: settings.contact.phone }) }}</span
                  ><br />
                  <span v-if="settings">
                    {{ $t("partner.PartnerFooter.web") }}
                    <a
                      :style="`color:${color}; text-decoration: none;`"
                      :href="`${settings.websites[0].link}`"
                      target="_blank"
                    >
                      {{ settings.websites[0].text }} </a
                    ><br />
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" v-if="settings">
              <v-card color="transparent" flat>
                <v-card-text v-if="isOpeningTimeInformationPresent">
                  <span v-if="settings.openingHours.monday">
                    {{ $t("partner.PartnerFooter.monday") }}
                    {{ settings.openingHours.monday || $t("partner.PartnerFooter.openingHoursDefault") }}
                  </span>
                  <br />

                  <span v-if="settings.openingHours.tuesday">
                    {{ $t("partner.PartnerFooter.tuesday") }}
                    {{ settings.openingHours.tuesday || $t("partner.PartnerFooter.openingHoursDefault") }}
                  </span>
                  <br />

                  <span v-if="settings.openingHours.wednesday">
                    {{ $t("partner.PartnerFooter.wednesday") }}
                    {{ settings.openingHours.wednesday || $t("partner.PartnerFooter.openingHoursDefault") }}
                  </span>
                  <br />

                  <span v-if="settings.openingHours.thursday">
                    {{ $t("partner.PartnerFooter.thursday") }}
                    {{ settings.openingHours.thursday || $t("partner.PartnerFooter.openingHoursDefault") }}
                  </span>
                  <br />

                  <span v-if="settings.openingHours.friday">
                    {{ $t("partner.PartnerFooter.friday") }}
                    {{ settings.openingHours.friday || $t("partner.PartnerFooter.openingHoursDefault") }}
                  </span>
                  <br />

                  <span v-if="partnerProp.settings.openingHours.saturday">
                    {{ $t("partner.PartnerFooter.saturday") }}
                    {{
                      partnerProp.settings.openingHours.saturday || $t("partner.PartnerFooter.openingHoursDefault")
                    }} </span
                  ><br />

                  <span v-if="partnerProp.settings.openingHours.sunday">
                    {{ $t("partner.PartnerFooter.sunday") }}
                    {{ partnerProp.settings.openingHours.sunday || $t("partner.PartnerFooter.openingHoursDefault") }}
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-card-text class="font-weight-light">
                {{ poweredBy }}<br />
                All rights reserved.
              </v-card-text>
              <v-card-text class="font-weight-light">
                <a :style="`padding-bottom:10px; color:${color}; text-decoration: none;`" @click="goToImprint">
                  {{ $t("partner.PartnerFooter.imprint") }}
                </a>
                |
                <a :style="`padding-bottom:10px; color:${color}; text-decoration: none;`" @click="goToPrivacy">
                  {{ $t("partner.PartnerFooter.privacy") }}
                </a>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-card>
  </v-footer>
</template>

<script lang="ts">
import { PartnerEntity } from "@/models/partnerEntity";

import { Component, Prop, Vue } from "vue-property-decorator";
import { AssetRepository, AssetEnum } from "@/lib/AssetRepository";
import { ConfigModule } from "@/store/modules/config";

@Component({})
export default class PartnerFooter extends Vue {
  @Prop()
  partnerProp?: PartnerEntity;

  @Prop()
  color?: string;

  @Prop({ default: "white" })
  fontColor?: string;

  @Prop({ default: true })
  showLogo!: boolean;

  @Prop({ default: "© mint software GmbH." })
  poweredBy!: string;

  get boxShadow() {
    return "0 50vh 0 50vh " + this.color;
  }

  get address() {
    return this.partnerProp?.address;
  }

  get settings() {
    return this.partnerProp?.settings;
  }

  get isWebsitePresent() {
    return this.settings && this.settings?.websites;
  }

  get isOpeningTimeInformationPresent() {
    return this.settings && this.settings?.openingHours;
  }

  get logoDamageReport() {
    return AssetRepository.getAsset(ConfigModule.darkMode, AssetEnum.damageReportLogo);
  }

  get overlaySrc() {
    return AssetRepository.getAsset(ConfigModule.darkMode, AssetEnum.footerBackground);
  }

  goToImprint() {
    this.$router.push({ name: "Imprint" });
  }

  goToPrivacy() {
    this.$router.push({ name: "Privacy" });
  }
}
</script>
